import data from "@/data/data"

const fetchAllCategories = () => {
  return data.categories
}

export { fetchAllCategories }
